import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, MenuItem, Divider } from '@mui/material';
import { specimenTypes, transferDestinations, patientConditionSuggestions } from '../../constants/options';

const PathologySection = ({ formData, handleChange }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 8: Pathology & Condition
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            size="small"
            options={specimenTypes}
            value={formData.type_of_specimen || ''}
            onChange={(_, newVal) => handleChange({ target: { name: "type_of_specimen", value: newVal } })}
            renderInput={(params) => <TextField {...params} label="Type of Specimen" fullWidth />}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Lab"
            fullWidth
            name="lab"
            value={formData.lab || ''}
            onChange={handleChange}
            size="small"
          >
            {["Pathology", "Cytology", "Microbiology", "Biochemistry"].map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
          </TextField>
        </Grid>
      </Grid>

      <Typography variant="subtitle1" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>Frozen Section</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <TextField label="Time Sent" type="time" fullWidth name="frozen_section_time_sent" value={formData.frozen_section_time_sent || ''} onChange={handleChange} InputLabelProps={{ shrink: true }} size="small" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField label="Time Received" type="time" fullWidth name="frozen_section_time_received" value={formData.frozen_section_time_received || ''} onChange={handleChange} InputLabelProps={{ shrink: true }} size="small" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField label="Pathologist Name" fullWidth name="name_of_pathologist" value={formData.name_of_pathologist || ''} onChange={handleChange} size="small" />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>Final Disposition & Status</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
              select
              label="Patient Condition"
              fullWidth
              name="condition_of_patient"
              value={formData.condition_of_patient || ''}
              onChange={handleChange}
              size="small"
            >
              <MenuItem value="Stable">Stable</MenuItem>
              <MenuItem value="Critical">Critical</MenuItem>
            </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            size="small"
            options={transferDestinations}
            value={formData.transferred_to_recovery_icu || ''}
            onChange={(_, newVal) => handleChange({ target: { name: "transferred_to_recovery_icu", value: newVal } })}
            renderInput={(params) => <TextField {...params} label="Transferred to Recovery/ICU" fullWidth />}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={patientConditionSuggestions}
            value={formData.condition_of_patient_text || ''}
            onChange={(_, newVal) => handleChange({ target: { name: "condition_of_patient_text", value: newVal } })}
            renderInput={(params) => <TextField {...params} label="Detailed Condition Notes" fullWidth multiline rows={3} />}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PathologySection;
